


























































import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';

import { Report as terms } from '@/const/terms/mainTerms';
import { ComponentTerms as compTerms } from '@/const/terms/componentTerms';
import { ReportConfirm } from '@/const/terms/feedback/confirm';
import { ReportDefault as feedbackTerms } from '@/const/terms/feedback/report';

import { IGridOptions, DefaultGridOptions, DefaultColumnOptions, GroupColumnOptions, NumberColumnOptions } from '@/const/options/TuiGridTypes';
import {
    IWrapReport,
    WrapReportType,
    MonthlyAppReportType,
    IMonthlyAppReport,
} from './types';

import { Grid } from '@toast-ui/vue-grid';
import tuiGrid from 'tui-grid';
import { ORIGIN_FORMAT } from '@/utils';
import { TUI_FORMAT } from '@/utils/toastGrid_formatter';

import { AxiosError, AxiosResponse } from 'axios';

type RowType = tuiGrid.IRow & (IWrapReport | IMonthlyAppReport) & { rowKey: tuiGrid.RowKeyType };

@Component<ReportSalesMonthly>({
    name: 'ReportSalesMonthly',
    components: {
        Grid,
    },
})
export default class ReportSalesMonthly extends Vue {
    private terms = terms;
    private compTerms = compTerms;
    private confirmTerms = ReportConfirm;

    private loading: boolean = false;
    private subLoading: number = 0; // element ui 2.9.1 이후 부터 지원함 하지만 2.9.1에 에러 너무 많음
    private isUtilsCollapsed: boolean = false;
    private allExpandToggleConfirmVisible: boolean = false;
    private isAllExpanded: boolean = false;
    private month: Date = new Date();
    private compareMonth: Date | string = '';

    private tableData: WrapReportType = [];
    private compareData: WrapReportType = [];
    private gridOptions: IGridOptions = {
        ...DefaultGridOptions,
        treeColumnOptions: {
            useIcon: true,
            name: 'app',
            useCascadingCheckbox: false,
        },
        summary: {
            defaultContent: '',
            position: 'bottom',
            height: 40,
            columnContent: {
                app: { template: (summary: tuiGrid.IValueMap) => '<strong>TOTAL</strong>' },
                totalSales: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '원', 'totalSales') },
                sspSales: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '원', 'sspSales') },
                adServerSales: { template: (summary: tuiGrid.IValueMap) => this.summaryFormat(summary, 'sum', '원', 'adServerSales') },
            }
        },
        columns: [
            { title: compTerms.column.app, name: 'app',formatter: this.appNameFormat, ...GroupColumnOptions },
            { title: compTerms.column.totalSales, name: 'totalSales', formatter: this.moneyFormat, ...NumberColumnOptions },
            { title: compTerms.column.sspSales, name: 'sspSales', formatter: this.moneyFormat, ...NumberColumnOptions },
            { title: compTerms.column.adServerSales, name: 'adServerSales', formatter: this.moneyFormat, ...NumberColumnOptions },
            // { title: compTerms.column.partner, name: 'partner', ...DefaultColumnOptions },
            { title: compTerms.column.advertiser, name: 'advertiser', ...DefaultColumnOptions },
            { title: compTerms.column.eachSales, name: 'eachSales', formatter: this.moneyFormat, ...DefaultColumnOptions },
        ]
    };
    private appNameFormat(cellValue: string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        if (this.tableData.length !== 0 && this.compareData.length !== 0 && rowAttrs && rowAttrs[column.name] !== undefined ) {
            if (rowAttrs._treeData) {
                const tree = rowAttrs._treeData as {
                    childrenRowKeys?: tuiGrid.RowKeyType[] | boolean;
                    hasNextSibling?: boolean[];
                    parentRowKey?: tuiGrid.RowKeyType;
                };
                if (tree.parentRowKey === undefined ) {
                    return cellValue + TUI_FORMAT.InRowDateRangeTagFormat([this.month, this.compareMonth] as Date[], 'YY-MM', ' X ');
                } else {
                    return cellValue + (
                        (rowAttrs.forCompare !== undefined && rowAttrs.forCompare) ? 
                            TUI_FORMAT.InRowDateTagFormat(this.compareMonth as Date, 'YY-MM', '', ' (비교)')
                            :
                            TUI_FORMAT.InRowDateTagFormat(this.month as Date, 'YY-MM', '', ' (기존)')
                    );
                }
            }
        }
        return cellValue;
    }
    private moneyFormat(cellValue: string, rowAttrs: tuiGrid.IRow, column: tuiGrid.IColumnInfoOptions): string {
        if (this.tableData.length !== 0 && this.compareData.length !== 0 && rowAttrs && rowAttrs[column.name] !== undefined) {
            const compareItem = this.compareData.find((v) => v.id == rowAttrs.id) as IWrapReport & {[key: string]: number};
            if (compareItem && compareItem[column.name] !== undefined) {
                const origin: number = rowAttrs[column.name] as number;
                const compare: number = compareItem[column.name];
                if (compare === 0) {
                    return (
                        `<span class="tuiGridInRowPrefix">( - %) </span>` +
                        TUI_FORMAT.MoneyFormat(cellValue, rowAttrs, column)
                    );
                } else {
                    return (
                        `<span class="tuiGridInRowPrefix">(`+
                        `${TUI_FORMAT.NumberFormat((origin/compare)*100)} %) </span>` +
                        TUI_FORMAT.MoneyFormat(cellValue, rowAttrs, column)
                    );
                }
            }
        }

        return TUI_FORMAT.MoneyFormat(cellValue, rowAttrs, column);
    }
    private summaryFormat(params: tuiGrid.IValueMap, property: string, unit: string, columnName: string): string {
        if (this.tableData.length !== 0 && this.compareData.length !== 0) {
            let sumOrigin = 0;
            let sumCompare = 0;
            this.tableData.forEach( (item: any) => {
                sumOrigin += item[columnName];
                const compareItem = this.compareData.find((v) => v.id === item.id) as IWrapReport & {[key: string]: number};
                if (compareItem) {
                    sumCompare += compareItem[columnName];
                }
            })
            params.sum = sumOrigin;
            if (sumCompare !== 0) {
                return `(${TUI_FORMAT.NumberFormat((sumOrigin / sumCompare) * 100)} %) ${TUI_FORMAT.SummaryFormat(params, property, unit)}`;
            } else {
                return `( - %) ${TUI_FORMAT.SummaryFormat(params, property, unit)}`;
            }
        }        
        return TUI_FORMAT.SummaryFormat(params, property, unit);
    }

    get compareMonthDate() {
        return moment(this.compareMonth).format('YYYY-MM');
    }
    get batchData() { // N == 30 or 31 / N이 늘어나면 Date Fetch 시에 hash table (map) 필요
        let batch: WrapReportType = [];
        if (this.compareData.length) {
            this.tableData.forEach((item) => {
                const now: IWrapReport = Object.assign({}, item);
                const comp: IWrapReport = Object.assign({}, this.compareData.find((v) => v.id === item.id) as IWrapReport);
                const parent: IWrapReport = Object.assign({}, item);
                parent._children = [now] as WrapReportType;
                if (comp) {
                    parent._children.push(comp);
                }
                parent._extraData = {
                    className: {
                        row: ['tuiGridTreeRoot'],
                    },
                };
                batch.push(parent);
            });
        } else {
            batch = this.tableData;
        }
        return batch;
    }

    private toggleAllHandler() {
        this.allExpandToggleConfirmVisible = false;
        if (this.loading || this.subLoading > 0) {
            return;
        }
        const table = this.$refs.table as Grid;
        const rows = table.invoke('getRows') as tuiGrid.IRow[] & WrapReportType & { rowKey: tuiGrid.RowKeyType }[];
        this.loading = true;
        setTimeout(() => {
            if (this.isAllExpanded) {
                // rows.forEach((item: any) => {
                //     const row = item as tuiGrid.IRow & IWrapReport & { rowKey: tuiGrid.RowKeyType };
                //     if (row._children === true
                //         || (row._treeData !== undefined && (row._treeData as any).childrenRowKeys && (row._treeData as any).childrenRowKeys.length !== 0) 
                //         || (row._children !== undefined && row._children !== false)
                //      ) {
                //         table.invoke('collapse', row.rowKey, true);
                //     }
                // })
                table.invoke('collapseAll');
            } else {
                // rows.forEach((item: any) => {
                //     const row = item as tuiGrid.IRow & IWrapReport & { rowKey: tuiGrid.RowKeyType };
                //     if (row._children === true
                //         || (row._treeData !== undefined && (row._treeData as any).childrenRowKeys && (row._treeData as any).childrenRowKeys.length !== 0) 
                //         || (row._children !== undefined && row._children !== false)
                //      ) {
                //          table.invoke('expand', row.rowKey, true);
                //     }
                // })
                table.invoke('expandAll');
            }
            this.isAllExpanded = !this.isAllExpanded;
            this.loading = false;
        }, 100)
    }
    // private expandedHandler({ rowKey, descendantRowKeys, instance }: tuiGrid.IColumnEventOptions & { descendantRowKeys: number[] | string[] | undefined[] }) {
    //     return;
    //     const table = this.$refs.table as Grid;
    //     const row = table.invoke('getRow', rowKey) as tuiGrid.IRow & IWrapReport;
    //     if (descendantRowKeys.length === 0 && row._children === true) {
    //         this.subLoading++;
    //         table.invoke('addRowClassName', rowKey, 'tuiGridTreeTerminalWrapper');
    //         this.getChildData(row.forCompare).then((res: any) => res.data)
    //             .then((data: MonthlyAppReportType) => {
    //                 data.forEach((item) => {
    //                     item.forCompare = row.forCompare;
    //                     item._extraData = {
    //                         className: {
    //                             row: ['tuiGridTreeTerminal'],
    //                         },
    //                     };
    //                 });
    //                 setTimeout(() => {
    //                     table.invoke('appendRow', data as tuiGrid.IRow[] & MonthlyAppReportType, { parentRowKey: rowKey })
    //                     this.subLoading--;
    //                 });
    //             })
    //             .catch((err: AxiosError) => {
    //                 if (err.response && (err.response as AxiosResponse).status !== 200) {
    //                     this.$notify.error(feedbackTerms.getResponse.error.fail);
    //                 } else {
    //                     this.$notify.error(err.message);
    //                 }
    //             })
    //     }
    // }
    private toggleUtilCollapsed() {
        this.isUtilsCollapsed=!this.isUtilsCollapsed;
        this.$nextTick(this.resizeHandler);
    }
    private resizeHandler() {
        const table = this.$refs.table as Grid;
        table.invoke('refreshLayout');
    }
    private excelDownloadHandler() {
        const table = this.$refs.table as Grid;
        const columns = table.invoke('getColumns') as tuiGrid.IColumnInfoOptions[];
        const json = JSON.stringify(table.invoke('getRows') as RowType[]);
        const refinedJson = json
                .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>.[<>a-zA-Z0-9 =\\\/"-]*.<[/]span>/g, '')
                .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>/g, '')
                .replace(/<i.[\s\S].[a-z]*=.[a-z\"\\-]*><\/i>/g, '')
                .replace(/<\/span>/g, '');
        const rows = JSON.parse(refinedJson) as RowType[];
        let content = "";
        let cnt = 0;
        const keys: string[] = columns.map((item: tuiGrid.IColumnInfoOptions) => item.name);
        columns.forEach((item: tuiGrid.IColumnInfoOptions, index: number) => {
            if (index !== 0) content += ',';
            content += '"' + item.title + '"';
        });

        enum thisRowIs {
            RootWrapper = 1,
            CompareWrapper,
            TerminalNode,
        }
        let currentChildKeys: tuiGrid.RowKeyType[] = [];
        rows.forEach((item: RowType) => {
            content += '\n';
            const isParagraph = 
                (item['_treeData' as keyof RowType] as any)['childrenRowKeys'] &&
                !(item['_treeData' as keyof RowType] as any).hasOwnProperty('parentRowKey')
            
            let rowRole = thisRowIs.TerminalNode;
            if ((item['_treeData' as keyof RowType] as any)['childrenRowKeys']) {
                if ((item['_treeData' as keyof RowType] as any).hasOwnProperty('parentRowKey')) {
                    rowRole = thisRowIs.CompareWrapper;
                } else {
                    rowRole = thisRowIs.RootWrapper;
                    currentChildKeys = (item['_treeData' as keyof RowType] as any)['childrenRowKeys'] as number[];
                }
            }

            if (isParagraph) {
                content += '\n';
            }
            keys.forEach((key: string, index: number) => {
                if (index !== 0) content += ',';
                content += '"';
                const checkNum = Number.parseFloat(item[key as keyof RowType] as string);
                 if (!Number.isNaN(checkNum)) {
                    content += ORIGIN_FORMAT.NumberFormatOrigin(checkNum);
                } else if (item[key as keyof RowType]){
                    content += item[key as keyof RowType];
                }
                
                if (index === 0) {
                    if (this.compareMonth) {
                        switch(rowRole) {
                            case thisRowIs.RootWrapper:
                                content += ` _${moment(this.month).format('YYYY-MM')} X ${moment(this.compareMonth).format('YYYY-MM')}`;
                                break;
                            case thisRowIs.CompareWrapper:
                                content += currentChildKeys[0] === item.rowKey ? 
                                    ` _${moment(this.month).format('YYYY-MM') } (기존)`
                                    :
                                    ` _${moment(this.compareMonth).format('YYYY-MM')} (비교)`;
                                break;
                            case thisRowIs.TerminalNode:
                                content += currentChildKeys[0] === (item['_treeData'] as any)['parentRowKey'] ? '(기존)' : '(비교)';
                                break;
                        }
                    }
                }
                content += '"';
            })
            if (isParagraph) {
                cnt++;
                content += ",,** "+cnt+`${item.app ? '. ' + item.app : ''}` +" **";
            }
        })
        const BOM = "\uFEFF";
        content = BOM + content
        const url = window.URL.createObjectURL(new Blob([content], {type: "text/csv"}));
        const link = document.createElement('a');
        link.href = url;
        
        link.setAttribute('download', `[${terms.sales.monthly.title}]_${moment(this.month).format('YYYY-MM')}` + (this.compareMonth ? `X${moment(this.compareMonth).format('YYYY-MM')}.csv` : '.csv'));
        link.click();
        this.subLoading--;
        return;


        // const json: string = JSON.stringify(this.batchData);
        // const url = window.URL.createObjectURL(new Blob([
        //     json
        //         .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>.[<>a-zA-Z0-9 =\\\/"-]*.<[/]span>/g, '')
        //         .replace(/<span.[\S\s].[a-zA-Z=/"\\]*>/g, '')
        //         .replace(/<i.[\s\S].[a-z]*=.[a-z\"\\-]*><\/i>/g, '')
        //         .replace(/<\/span>/g, '')
        // ]));
        // const link = document.createElement('a');
        // link.href = url;
        // link.setAttribute('download', `${moment(this.month).format('YYYY-MM')}.json`)
        // link.click();
    }

    private setCompareData(val: string) {
        this.loading = true;
        this.subLoading++;
        this.getAppData(true).then((res: any) => res.data)
            .then((data: WrapReportType) => {
                this.compareData = data.map((item) => {
                    return {
                        ...item,
                        totalSales: item.sspSales + item.adServerSales,
                        forCompare: true,
                        _children: item.advertisers.sort((a: IMonthlyAppReport, b: IMonthlyAppReport) => {
                                if (a.eachSales === b.eachSales) {
                                    return a.advertiser < b.advertiser ? -1 : 1;   
                                }
                                return a.eachSales < b.eachSales ? 1 : -1;
                            })
                            .map((item: IMonthlyAppReport) => ({
                                ...item,
                                forCompare: true,
                                _extraData: {
                                    className: {
                                        row: ['tuiGridTreeTerminal'],
                                    },
                                },
                            })),
                        _extraData: {
                            className: {
                                row: ['tuiGridTreeTerminalWrapper'],
                            },
                        },
                    };
                });
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(() => {
                this.loading = false;
                this.subLoading--;
                this.isAllExpanded = false;
            })
    }

    private refreshData(date: Date) {
        if (date) {
            this.getAppDataHandler();
        }
    }
    private getAppDataHandler() {
        this.loading = true;
        this.subLoading++;
        this.getAppData().then((res: any) => res.data)
            .then((data: WrapReportType) => {
                this.tableData = data.map((item: IWrapReport) => {
                    return {
                        ...item,
                        totalSales: item.sspSales + item.adServerSales,
                        forCompare: false,
                        _children: item.advertisers.sort((a: IMonthlyAppReport, b: IMonthlyAppReport) => {
                                if (a.eachSales === b.eachSales) {
                                    return a.advertiser < b.advertiser ? -1 : 1;   
                                }
                                return a.eachSales < b.eachSales ? 1 : -1;
                            })
                            .map((item: IMonthlyAppReport) => ({
                                ...item,
                                forCompare: false,
                                _extraData: {
                                    className: {
                                        row: ['tuiGridTreeTerminal'],
                                    },
                                },
                            })),
                        _extraData: {
                            className: {
                                row: ['tuiGridTreeTerminalWrapper'],
                            },
                        },
                    };
                });
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(() => {
                this.isAllExpanded = false;
                this.loading = false;
                this.subLoading--;
            })
    }

    private getAppData(isCompare = false) {
        return this.$http.adserverAPI.post('GetSalesMonthlyReport', {
            date: moment(isCompare ? this.compareMonth: this.month).format('YYYYMM'),
        });
    }

    private mounted() {
        this.$nextTick(() => {
            this.getAppDataHandler();
        })
    }
}
